import { configureStore } from '@reduxjs/toolkit';
import authReducer    from './slices/authSlice';
import uiReducer      from './slices/uiSlice';
import scopeFilterReducer from './slices/scopeFilterSlice';

const store = configureStore({
  reducer: {
    auth:    authReducer,
    ui:      uiReducer,
    scopeFilter: scopeFilterReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // Allow non-serializable values like timers
    }),
});

export { store };
export default store;